export const initialState = {
  procedure: '',
  dateOfSurgery: null,
  comments: '',
};
